import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "../css/Letuslogin.css";
import { useAuth0 } from "@auth0/auth0-react";

const Letuslogin = () => {
  const { loginWithRedirect, isAuthenticated, user } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated && user?.email) {
      const email = user.email;
      const username = user.nickname || "Unknown";

      fetch('https://snapcourse.in/contentapi/diary/verify-admin.php', { 
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      })
      .then(response => response.json())
      .then(data => {
        const status = data.isAdmin ? "success" : "failed";

        // Log the login attempt in the database
        fetch('https://snapcourse.in/contentapi/diary/record_login_attempt.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, username, status }),
        });

        if (data.isAdmin) {
          navigate('/admindashboard');
        } else {
          alert("Unauthorized access. Your email is not registered as an admin.");
        }
      })
      .catch(error => {
        console.error("Error verifying admin:", error);
      });
    }
  }, [isAuthenticated, user, navigate]);

  return (
    <div className="login-container">
      <h1>CIA DATA</h1>
      <p className="google-log" onClick={() => loginWithRedirect()}>
        Unauthorized Login Try Can Cause Legal Action
      </p>
      <p className='text-danger'>Your Login Attempt Will Be Recorded For Security Purpose</p>
    </div>
  );
};

export default Letuslogin;
